import React, { useState, useEffect } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import cross from "../../assets/images/icon/cross.svg";
function ConfirmationModal({
  show,
  handleClose,
  handleConfirm,
  message,
  appl_id,
  status,
}) {
  const [comment, setComment] = useState("");
  let placeholder;
  if (status == 4) {
    placeholder = "Comment is compulsory to put the candidate on hold.**";
  } else if (status == 5) {
    placeholder = "Comment is compulsory to put the candidate on Rejected.**";
  } else {
    placeholder = "Add Comment**";
  }
  const handleChange = e => {
    setComment(e.target.value);
  };

  useEffect(() => {
    if (show) {
      const timeout = setTimeout(() => {
        const modalBackdrop = document.querySelector(".modal-backdrop");
        if (modalBackdrop) {
          modalBackdrop.classList.add("edit-cksisjs");
        }
      }, 10); // Adjust the delay as necessary

      return () => clearTimeout(timeout);
    }
  }, [show]);

  return (
    <div className="edit-modal">
      <Modal show={show} onHide={handleClose} className="edit-modal-card">
        {/* <Modal.Header closeButton>
          <Modal.Title>{message}</Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div className="filters-cards-cross">
            <div className="filter-content">
              <h4>{message}</h4>
            </div>
            <div className="filter-content cross" onClick={handleClose}>
              <img src={cross} alt="" />
            </div>
          </div>
          <div className="bordertops"></div>
          <Form className="form-modal">
            <div className="form-group">
              <div className="row">
                <div
                  id="address-group"
                  className="form-group form-group-lg col-sm-12"
                >
                  <label>Enter Comment:</label>
                  <textarea
                    rows="5"
                    className="form-control"
                    onChange={handleChange}
                    name="comment"
                    id="comment"
                    placeholder={placeholder}
                    title={`Please enter comment`}
                  ></textarea>
                </div>
              </div>
            </div>
            <div className="serach-btn modal-action-btn text-center mt-2  d-flex gap-3">
              <button className="m-2 btn btn-secondary" onClick={handleClose}>
                Cancel
              </button>
              <button
                type="submit"
                onClick={() => handleConfirm(appl_id, status, comment)}
                className="btn btn-primary"
              >
                Submit
              </button>
            </div>
          </Form>
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
}

export default ConfirmationModal;
